import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const LeoPromotionRibbon = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  columnGap: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  height: theme.spacing(4.5),
  maxHeight: theme.spacing(4.5),
  maxWidth: '100%'
}));

export const LeoPromotionRibbonLabel = styled(Typography)(({theme}) => ({
  lineHeight: theme.spacing(2),
  fontSize: theme.spacing(1.5),
  color: theme.palette.common.black,
  flexGrow: 1,
  display: 'flex',
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.25),
  height: theme.spacing(3.25),
  alignItems: 'center',
  flexBasis: '90%',
  columnGap: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  width: '118px',
  textWrap: 'nowrap',
  backgroundColor: '#FFF7D4',
  '> span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));

export const LeoPromotionRibbonCount = styled('span')(({theme}) => ({
  fontWeight: 600,
  borderRadius: '50%',
  textAlign: 'center',
  display: 'inline-block',
  height: theme.spacing(2.5),
  width: theme.spacing(2.5),
  fontSize: theme.spacing(1.25),
  color: theme.palette.common.black,
  padding: `${theme.spacing(0.5)} 0`,
  backgroundColor: theme.palette.common.white
}));
